import Lenis from "@studio-freight/lenis";

const Component_SmoothScroll = () => {
	if (typeof Lenis !== "function") {
		document.documentElement.style.overflow = "auto";
		return;
	}

	let lenis;

	try {
		lenis = new Lenis({
			smooth: true,
		});

		function raf(time) {
			lenis.raf(time);
			requestAnimationFrame(raf);
		}
		requestAnimationFrame(raf);

		// Anchor-Links über Lenis scrollen
		const onAnchorClick = (e) => {
			const link = e.target.closest('a[href^="#"]');
			if (!link) return;

			const href = link.getAttribute("href");
			if (!href || href === "#") return;

			const id = decodeURIComponent(href.slice(1));
			const target = document.getElementById(id);
			if (!target) return;

			e.preventDefault();

			// URL aktualisieren, aber ohne hartes Springen
			history.pushState(null, "", `#${encodeURIComponent(id)}`);

			lenis.scrollTo(target, {
				offset: 0,
				immediate: false,
			});
		};

		document.addEventListener("click", onAnchorClick, true);

		// Optional: Wenn Seite mit Hash geladen wird, auch smooth hin scrollen
		if (window.location.hash && window.location.hash.length > 1) {
			const id = decodeURIComponent(window.location.hash.slice(1));
			const target = document.getElementById(id);
			if (target) {
				requestAnimationFrame(() => {
					lenis.scrollTo(target, { offset: 0, immediate: false });
				});
			}
		}

		// Falls du später mal destroyen willst:
		// return () => {
		//   document.removeEventListener("click", onAnchorClick, true);
		//   lenis.destroy();
		// };
	} catch (error) {
		document.documentElement.style.overflow = "auto";
		document.body.style.overflow = "auto";
	}
};

export default Component_SmoothScroll;
